import expiryLocalStorage from '../../../../components/expiry-local-storage';

let instance = null;
const TTL = 172800000; // 48 hours in ms
const KEY_STEPS = 'questions';

/**
 * QuestionsLSContainer - Questions LocalStorage Container (singleton). Stores in localStorage data about questions.
 * Uses expiryLocalStorage with `TTL` to store the data.
 */
class QuestionsLSContainer {
	constructor() {
		if (!instance) {
			instance = this;
		}

		return instance;
	}

	getAllQuestions() {
		let questions = {}

		try {
			const questionsFromStorage = expiryLocalStorage.getWithExpiry(KEY_STEPS);

			if (questionsFromStorage) {
				questions = questionsFromStorage;
			}
		} catch (e) {
			console.error(e);
		}

		return questions;
	}

	setAllQuestions(questions) {
		try {
			expiryLocalStorage.setWithExpiry(KEY_STEPS, questions, TTL);
		} catch (e) {
			console.error(e);
		}
	}

	set(pageId, data) {
		if (!pageId || !data) {
			return;
		}

		const questions = this.getAllQuestions();
		questions[pageId] = data;

		this.setAllQuestions(questions);
	}

	get(pageId) {
		const questions = this.getAllQuestions();
		const data = questions[pageId] ? questions[pageId] : null;

		return data;
	}

	remove(pageId) {
		const questions = this.getAllQuestions();

		if (questions[pageId]) {
			delete questions[pageId];
			this.setAllQuestions(questions);
		}
	}
}

export default new QuestionsLSContainer();
